import React from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Download, Upload, FileSpreadsheet } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AdminImportExport() {
    const [uploading, setUploading] = React.useState(false);
    const [result, setResult] = React.useState(null);
    const [dateFrom, setDateFrom] = React.useState("");
    const [dateTo, setDateTo] = React.useState("");

    const downloadCsv = (path, filename) => {
        // Reuse axios token
        const token = localStorage.getItem("st_token");
        fetch(`${BACKEND}${path}`, { headers: { Authorization: `Bearer ${token}` } })
            .then(r => r.blob()).then(b => {
                const url = URL.createObjectURL(b);
                const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
                URL.revokeObjectURL(url);
            });
    };

    const importProducts = async (e) => {
        const f = e.target.files?.[0]; if (!f) return;
        setUploading(true); setResult(null);
        try {
            const fd = new FormData(); fd.append("file", f);
            const r = await api.post("/admin/products/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
            setResult(r.data);
            toast.success(`Import ok: ${r.data.created} create, ${r.data.updated} actualizate${r.data.errors ? `, ${r.data.errors} erori` : ""}`);
        } catch (err) { toast.error(err.response?.data?.detail || "Eroare"); }
        setUploading(false);
    };

    return (
        <div className="max-w-3xl" data-testid="admin-import">
            <div className="overline mb-1">Administrare</div>
            <h1 className="font-heading text-3xl mb-6">Import & Export</h1>

            <div className="card-soft p-5 mb-4">
                <h3 className="font-heading text-lg mb-3 flex items-center gap-2"><Download className="h-5 w-5 text-primary" /> Export produse (CSV)</h3>
                <p className="text-sm text-muted-foreground mb-3">Descarcă întregul catalog de produse într-un CSV editabil.</p>
                <button onClick={() => downloadCsv("/api/admin/products/export", `produse.csv`)} className="btn-primary" data-testid="export-products">Descarcă produse CSV</button>
            </div>

            <div className="card-soft p-5 mb-4">
                <h3 className="font-heading text-lg mb-3 flex items-center gap-2"><Download className="h-5 w-5 text-primary" /> Export comenzi (CSV)</h3>
                <p className="text-sm text-muted-foreground mb-3">Filtru opțional după interval de date.</p>
                <div className="flex flex-wrap gap-2 items-end">
                    <div><label className="text-xs text-muted-foreground">De la</label><input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className="input-soft !py-2" /></div>
                    <div><label className="text-xs text-muted-foreground">Până la</label><input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className="input-soft !py-2" /></div>
                    <button onClick={() => {
                        const p = new URLSearchParams();
                        if (dateFrom) p.set("date_from", dateFrom);
                        if (dateTo) p.set("date_to", dateTo);
                        downloadCsv("/api/admin/orders/export?" + p.toString(), "comenzi.csv");
                    }} className="btn-primary" data-testid="export-orders">Descarcă</button>
                </div>
            </div>

            <div className="card-soft p-5">
                <h3 className="font-heading text-lg mb-3 flex items-center gap-2"><Upload className="h-5 w-5 text-primary" /> Import produse (CSV)</h3>
                <p className="text-sm text-muted-foreground mb-3">
                    Încarcă un fișier CSV cu coloanele: <code className="text-xs bg-muted px-1">code, name, slug, brand, category_id, price, sale_price, stock, stock_supplier, low_stock_threshold, is_critical, manual_out_of_stock, supplier_order_enabled, active, short_description</code>.
                    Produsele existente (după <code>code</code> sau <code>product_id</code>) se vor actualiza.
                </p>
                <label className="btn-primary cursor-pointer inline-flex items-center gap-2" data-testid="import-products-btn">
                    <FileSpreadsheet className="h-4 w-4" /> {uploading ? "Se procesează..." : "Alege CSV"}
                    <input type="file" accept=".csv,text/csv" className="hidden" onChange={importProducts} disabled={uploading} />
                </label>
                {result && (
                    <div className="mt-4 card-soft p-3 bg-muted">
                        <div>Create: <strong>{result.created}</strong> · Actualizate: <strong>{result.updated}</strong> · Erori: <strong>{result.errors}</strong></div>
                        {result.error_messages?.length > 0 && (
                            <ul className="text-xs text-destructive mt-2">
                                {result.error_messages.map((m, i) => <li key={i}>{m}</li>)}
                            </ul>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
